import { sum } from 'lodash';
import React from 'react';
import { useIsBasicOperate } from '@/framework';
import { BaseCells } from '@/version-types';
import { useTableEditState } from '../state';
import './table-cell-selected-rect.less';

export const tableCellSelectedRectId = 'tableCell-selectedRect';

const TableCellSelectedRect: React.FC<{
    baseCells: BaseCells;
    style?: React.CSSProperties;
}> = ({ baseCells: { horizontal: hSizes, vertical: vSizes }, style: styleProp }) => {
    const isBasicOperationState = useIsBasicOperate();
    const cellsSelectedInfo = useTableEditState()((s) => s.cellsSelectedInfo);
    const lineIsDragging = useTableEditState()((s) => s.lineIsDragging);
    if (!cellsSelectedInfo) return null;
    if (isBasicOperationState || lineIsDragging) return null;

    const { startHIndex, startVIndex, endHIndex, endVIndex } = cellsSelectedInfo.rect;

    const style: React.CSSProperties = {
        top: sum(vSizes.slice(0, startVIndex)),
        left: sum(hSizes.slice(0, startHIndex)),
        width: sum(hSizes.slice(startHIndex, endHIndex)),
        height: sum(vSizes.slice(startVIndex, endVIndex)),
        ...styleProp,
    };

    return <div id={tableCellSelectedRectId} style={style}></div>;
};

TableCellSelectedRect.displayName = 'TableCellSelectedRect';

export default TableCellSelectedRect;
